/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LpInspectionCouponDto } from '../../models/lp-inspection-coupon-dto';
import { OffsetPaginationDto } from '../../models/offset-pagination-dto';

export interface NonMemberControllerSearchCoupon$Params {

/**
 * 페이지 크기
 */
  pageSize: number;

/**
 * 정렬 기준
 */
  orderBy?: string;

/**
 * 정렬 방향
 */
  align?: 'asc' | 'desc';

/**
 * 검색어
 */
  query?: string;

/**
 * 페이지 번호
 */
  pageNo: number;

/**
 * 그룹 ID
 */
  groupId?: string;

/**
 * 아동 ID
 */
  childId?: string;

/**
 * 상태
 */
  status?: Array<string>;
}

export function nonMemberControllerSearchCoupon(http: HttpClient, rootUrl: string, params: NonMemberControllerSearchCoupon$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto & {
'items'?: Array<LpInspectionCouponDto>;
}>> {
  const rb = new RequestBuilder(rootUrl, nonMemberControllerSearchCoupon.PATH, 'get');
  if (params) {
    rb.query('pageSize', params.pageSize, {});
    rb.query('orderBy', params.orderBy, {});
    rb.query('align', params.align, {});
    rb.query('query', params.query, {});
    rb.query('pageNo', params.pageNo, {});
    rb.query('groupId', params.groupId, {});
    rb.query('childId', params.childId, {});
    rb.query('status', params.status, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OffsetPaginationDto & {
      'items'?: Array<LpInspectionCouponDto>;
      }>;
    })
  );
}

nonMemberControllerSearchCoupon.PATH = '/api/non-member/search/offset/coupon';
